import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { ButtonStandard } from "../../components";
import "./NormList.scss"
import messages from "../../assets/i18n";
import ItemList from '../../containers/ItemList/ItemList'

function NormList(props) {

	const dispatch = useDispatch();
    const history = useHistory();

	const lang = useSelector(state => state.language.name);

	const declarationNormList = useSelector(state => state.producerDeclaration.normList);
    const selectedNorm        = useSelector(state => state.producerDeclaration.selectedNorm);
    
	const pageMessages = messages[lang].normListPage;
	const titleTable   = messages[lang].norms;
    const titlePage    = messages[lang].normsInquiry;

	const header = [
		pageMessages.codigo,
		pageMessages.descricao,
		pageMessages.ativo,
        ""
	];
    
    useEffect(() => {
		dispatch({
			type: 'GET_DECLARATION_NORMS',
		})
        // eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

    useEffect(() => {
		if (selectedNorm) {
			history.push('/norm-details')
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedNorm]);

	const mappedNormList = () => {
		return declarationNormList.map((item) => {
			return [
					item.codigo,
                    item.descricao,
					item.ativo,
                    {
						text: <i className="icon-pen" />,
						onClick: () => {
							dispatch({
								type: 'SET_SELECTED_NORM',
								payload: item.id
							})
						},
					},
				]

		});
	}

	return (
		<div className="norm-list-page">
            <Container className="pt-3 justify-content-start">
                <Row className="justify-content-between">
                    <Col className="d-flex align-items-center justify-content-start">
                        <span className="text-3 font-weight-bold header-main pl-2">{titlePage}</span>
                    </Col>
                </Row>
            </Container>

            <Container className="px-4 d-flex justify-content-end">
				<ButtonStandard
					text={pageMessages.newNorm}
					textClass="text-1"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => history.push('/norm-details')}/>
			</Container>

            <Container className="pt-3 justify-content-start">
                <Container className="mt-1 pt-1 mb-4 pb-5">
                    <ItemList
                        header={header}
                        titleTable={titleTable}
                        listTable={mappedNormList()}
                        isLoading={declarationNormList.length > 0 ? false : true}
                        />
                </Container>
            </Container>            
		</div>
	)
}

export default withRouter(NormList);